import Locales from "../../language.json";
import {type TLocale} from "@/lib/@types/locale";

export const SITE_LOCALES: TLocale[] = Locales;

// 密码的限制
export const PASSWORD_LENGTH = {
    min: 8,
    max: 16
};

export const EXP_MSG = "Signature has expired";

